import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Card, Form, Input, InputNumber, message } from "antd";
import React, { useEffect } from "react";
import { getSystemValue, updateSystemValues } from "../utils/api";

const SystemValues = () => {
  const [systemValues, setSystemValues] = React.useState({});
  const [form] = Form.useForm();
  const { data, isLoading } = useQuery({
    queryKey: ["systemvalues"],
    queryFn: getSystemValue,
  });

  const { mutate, isPending } = useMutation({
    mutationFn: updateSystemValues,
    onSuccess: (data) => {
      message.success("System Values Updated Successfully");
    },
  });

  console.log(data);
  useEffect(() => {
    setSystemValues(data);
    form.setFieldsValue(data);
  }, [data, form]);
  return (
    <div
      style={{
        marginTop: "20px",
      }}
    >
      <Card
        title="System Values"
        style={{
          maxWidth: "500px",
          margin: "auto",
        }}
      >
        {" "}
        <Form
          title="System Values"
          form={form}
          layout="vertical"
          onFinish={(values) => {
            setSystemValues(values);
            mutate(values);
          }}
          initialValues={systemValues}
        >
          <Form.Item label="Upload Charge" name="uploadCharge">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item label="App Sharing Coin" name="appSharingCoin">
            <Input style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item label="Content Sharing Coin" name="contentSharingCoin">
            <Input style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item label="Admin Charges" name="adminCharges">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Coupon" name="referral">
            <Input style={{ width: "100%" }} />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={isPending || isLoading}
            style={{ width: "100%" }}
          >
            Update
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default SystemValues;
